import { useAppSelector } from "../store/hooks";
import { getHeldFhirClient } from "../services/fhir-client-holder";

/** Returns the fhirclient instance once FHIR initialization has completed. */
export const useFhirClient = () => {
  const isInitialized = useAppSelector((state) => state.fhir.isInitialized);
  return isInitialized ? getHeldFhirClient() : null;
};
